import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { placeholderMembersApi } from 'src/Services/API';
import { trackPlaceholderMemberDeleted } from 'src/Services/Mixpanel/events';
import { ApiError } from 'src/types/api-error.types';

export const useDeletePlaceholderMember = () => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<void, AxiosError<ApiError>, string>({
    mutationFn: async placeholderId => {
      await placeholderMembersApi.placeholderMembersControllerDelete(placeholderId);
    },
    onSuccess: () => {
      trackPlaceholderMemberDeleted({ asset_id: assetId ?? '' });
      queryClient.invalidateQueries(['fetch-members', assetId]);
      queryClient.invalidateQueries(['fetch-asset-details', assetId]);
      queryClient.invalidateQueries(['fetch-households', assetId]);
    },
  });
};
